import React, {Component} from 'react';
import {Card, Col, Divider, Row} from "antd";
import {withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {compose} from "redux";
import {connect} from "react-redux";
import {CompanyEmployees} from "./CompanyEmployees";
import {CompanyJoinRequests} from "./CompanyJoinRequests";
import LinkButton from "../Boilerplate/LinkButton";
import {QuickInviteButton} from "../Boilerplate/QuickInviteButton";
import {getMyCompany, quickInviteCompanyUserEmailSingle} from "../../actions/companies";
import {CompanyProfileDisplay} from "./CompanyProfileDisplay";
import {createSelector} from "reselect/es";
import CompanyLogo from "../Boilerplate/CompanyLogo";
import {withLoading} from "../Boilerplate/deferLoaderHoc"; // fix for Webstorm IDE code analysis

class CompanyProfile extends Component {
  state = ({ profileWidth: undefined });

  updateDimensions = () => {
    const node = document.querySelector('#company-profile-display');
    this.setState({ profileWidth: node && node.scrollWidth });
  };

  componentDidMount = () => {
    this.updateDimensions();
    return window.addEventListener('resize', this.updateDimensions);
  };

  componentWillUnmount = () => window.removeEventListener('resize', this.updateDimensions);

  render() {
    const { company, profile, onQuickInvite } = this.props;
    return <React.Fragment>
      <Row type={'flex'} gutter={'12'}>
        <Col xs={24} xl={8} className='bid-dashboard-info'>
          <Col xs={24} lg={12} xl={24} className='bid-dashboard-info'>
            {company && <CompanyLogo id={company.resource.id}/>}
          </Col>
          <Col xs={24} lg={12} xl={24} className='bid-dashboard-info'>
            <Card
              id={'company-profile-display'}
              className={'bid-dashboard-column-card'}
              title={<h1>Company Profile</h1>}
              extra={<React.Fragment>
                {company &&
                <LinkButton
                  icon={'profile'}
                  style={{ marginRight: 8 }}
                  to={`/@/${company.resource.companyname.replace(/[^\w]+/g, '').toLocaleLowerCase()}`}
                >
                  <span style={{ display: this.state.profileWidth < 430 && 'none' }}>Full Profile</span>
                </LinkButton>}
                {profile.companyadmin &&
                <LinkButton icon={'edit'} to='/settings/company-profile/edit'>
                  <span style={{ display: this.state.profileWidth < 430 && 'none' }}>Edit</span>
                </LinkButton>}
              </React.Fragment>}
            >
              <CompanyProfileDisplay/>
            </Card>
          </Col>
        </Col>
        <Col xs={24} xl={16} className={'bid-dashboard-info'}>
          <Card className={'bid-dashboard-column-card'} title={<h1>Company Employees</h1>}
                extra={
                  profile.companyadmin &&
                  <QuickInviteButton
                    title={'Add New Users to Company'}
                    onInvite={onQuickInvite}
                  />
                }>
            {profile.companyadmin &&
            <React.Fragment>
              <Divider>Company Join Requests</Divider>
              <CompanyJoinRequests/>
            </React.Fragment>
            }
            <Divider>Company Employees</Divider>
            <CompanyEmployees/>
          </Card>
        </Col>
      </Row>
    </React.Fragment>;
  }
}

const myCompany = createSelector(
  state => state.profile.companyid,
  state => state.companies.data,
  (companyId, companies) => companies[companyId]
);

export default compose(
  withBreadcrumbCurried({ title: 'Company Profile', path: '/settings/company-profile' }),
  connect(
    (state, props) => {
      if (!myCompany(state)) return { loading: true };
      return ({ profile: state.profile, company: myCompany(state) });
    },
    (dispatch, props) => ({
      loader: () => dispatch(getMyCompany()),
      onQuickInvite: (email) => dispatch(quickInviteCompanyUserEmailSingle(email)),
    }),
  ),
  withLoading,
)(CompanyProfile);



// WEBPACK FOOTER //
// ./src/components/Settings/CompanyProfile.js